import { render, staticRenderFns } from "./ViewBotaoVoltar.vue?vue&type=template&id=e2b5010a"
import script from "./ViewBotaoVoltar.vue?vue&type=script&lang=js"
export * from "./ViewBotaoVoltar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports